var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocationDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 246.492,
    height: 246.492,
    viewBox: "0 0 246.492 246.492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 174.296,
    height: 174.296,
    fill: "#1d254f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-location-default",
    transform: "translate(0 123.246) rotate(-45)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M58.727,117.015,83.943,53.962a3.659,3.659,0,0,1,6.806.028l24.832,63.632a3.66,3.66,0,0,1-5.941,3.973L89.618,102.409a3.659,3.659,0,0,0-5.031-.031L64.624,121.047a3.66,3.66,0,0,1-5.9-4.032",
    fill: "#1d254f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M87.148,174.3A87.148,87.148,0,1,1,174.3,87.148,87.246,87.246,0,0,1,87.148,174.3m0-159.3A72.148,72.148,0,1,0,159.3,87.148,72.229,72.229,0,0,0,87.148,15",
    fill: "#1d254f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocationDefault);
export default __webpack_public_path__ + "static/media/icon-location-default.707e9fa4ce4267ab74be79430e7d7be6.svg";
export { ForwardRef as ReactComponent };